module.exports = __webpack_public_path__ + "img/LogoChefTete_Color.06b31947.png";